import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { PhBhpObserveChartExportComponent } from '../ph-bhp-observe-chart-export/ph-bhp-observe-chart-export.component';
import { PhBhpPdfComplianceComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance/ph-bhp-pdf-compliance.component';
import { AppConfig } from 'src/app/app.config';
import { Subscription } from 'rxjs';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageEvaluationFilterService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluationfilter.service';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-observe-quota',
  templateUrl: './ph-bhp-observe-quota.component.html',
  styleUrls: ['./ph-bhp-observe-quota.component.css']
})
export class PhBhpObserveQuotaComponent implements OnInit, OnDestroy {

  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceComponent;
  @ViewChild('exportTag') export: PhBhpObserveChartExportComponent;
  @ViewChild('filter', { static: true }) filter: PhBhpFilterComponent;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  isDesktop = true;
  gridGroupable = true;
  gridData: Array<any>;
  userData;
  noDataFound: boolean = false;
  data;
  userSubscription: Subscription;
  pageInfo = {
    ofLabel: "GENERAL.OF", //'of',
    items: "CONFIGURE.QUOTAS",
    itemsPerPageLabel: "CONFIGURE.PER_PAGE.QUOTAS"
  };
  fields: Array<any>;
  isCallFor: string;
  pageTitle = 'Quota';
  appName = 'Observe';

  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;
  evaluationLoaded: boolean = false;
  lang: string;
  isEvaluationTable: boolean = true;
  isUserFilterSetted: boolean = true;
  userHasFilter: any = true;

  constructor(private router: Router,
    public appConfig: AppConfig,
    private service: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    private service2: PHBHPFeaturePackageEvaluationFilterService) {
    this.fields = [
      {
        'field': 'createdDateTimeStart', 'title': this.layoutService.translateText("CONFIGURE.START_DATE"),// 'Start date',
        // "ngTemplate": (dataItem) => {
        //   const date = this.layoutService.convertUTCStingToLocalDate(dataItem.quotainstitution.quota.startDateTime)
        //   let lang = localStorage.getItem('selectedlanguage');
        //   if (lang === 'en') {
        //     lang = 'en-GB';
        //   }
        //   return date.toLocaleDateString(lang, {month: '2-digit', day: '2-digit', year: 'numeric'});
        // }
      },
      {
        'field': 'createdDateTimeEnd', 'title': this.layoutService.translateText("CONFIGURE.END_DATE"),//'End date',
        // "ngTemplate": (dataItem) => {
        //   const date = this.layoutService.convertUTCStingToLocalDate(dataItem.quotainstitution.quota.endDateTime)
        //   let lang = localStorage.getItem('selectedlanguage');
        //   if (lang === 'en') {
        //     lang = 'en-GB';
        //   }
        //   return date.toLocaleDateString(lang, {month: '2-digit', day: '2-digit', year: 'numeric'});
        // }
      },
      {
        'field': 'institutionName', 'title': this.layoutService.translateText("EVALUATION.INSTITUTION"),
        // 'ngTemplate': (dataItem) => {
        //   // If dataItem.institution has more than 10 characters, then show only 10 characters and add '...' at the end
        //   const institutionName = dataItem.quotainstitution.institution.institution.institutionName;
        //   if (institutionName.length > 10  && !institutionName.includes(' ')) {
        //     return institutionName.substring(0, 12) + '...';
        //   } else {
        //     return institutionName;
        //  }
        // }
      },
      {
        'field': 'departmentName', 'title': this.layoutService.translateText("EVALUATION.DEPARTMENT"),//'Department',
        'ngTemplate': (dataItem) => {
          return dataItem.departmentName !== '' ? this.layoutService.translateText(dataItem.departmentName) : dataItem.departmentName;
        }
      },
      {
        'field': 'wardName', 'title': this.layoutService.translateText("CONFIGURE.WARD"),//'Ward',
        // 'ngTemplate': (dataItem) => {
        //   return dataItem.wardName !== '' ?  this.layoutService.translateText(dataItem.wardName) : dataItem.wardName;
        // }
      },
      { 'field': 'observedQuota', 'title': this.layoutService.translateText("EVALUATION.QUOTA_PROGRESS") },//'Observed quota' },
      { 'field': 'beforeTouchingAPatient', 'title': this.layoutService.translateText("EVALUATION.QUOTAS.MOMENT_1"), 'subtitle': this.layoutService.translateText("OBSERVATION.BEFORE.TOUCHING_PATIENT") },//'Before touching a patient' },
      { 'field': 'beforeCleanAsepticProcedures', 'title': this.layoutService.translateText("EVALUATION.QUOTAS.MOMENT_2"), 'subtitle': this.layoutService.translateText("OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1") },//'Before aseptic procedures' },
      { 'field': 'afterBodyFluidExposureRisk', 'title': this.layoutService.translateText("EVALUATION.QUOTAS.MOMENT_3"), 'subtitle': this.layoutService.translateText("OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK") },//'After body fluid exposure risk' },
      { 'field': 'afterTouchingAPatient', 'title': this.layoutService.translateText("EVALUATION.QUOTAS.MOMENT_4"), 'subtitle': this.layoutService.translateText("OBSERVATION.AFTER.TOUCHING_PATIENT") },//'After touching a patient' },
      { 'field': 'afterTouchingPatientSurrandings', 'title': this.layoutService.translateText("EVALUATION.QUOTAS.MOMENT_5"), 'subtitle': this.layoutService.translateText("OBSERVATION.AFTER.TOUCHING_SURROUNDINGS") },//'After touching patient surroundings' },
    ];
  }

  ngOnInit() {
    this.lang = localStorage.getItem('selectedlanguage') || 'en'
    if (this.appConfig.userData) {
      this.onInitQuota();
    } else {
      this.userSubscription = this.appConfig.userSubject.asObservable().subscribe((res) => {
        this.onInitQuota();
        this.evaluate(true);
      });
    }

    this.layoutService.lang.subscribe((res) => {
      this.lang = res;
      this.onInitQuota();
      this.evaluate(true);
    });

    this.layoutService.showLoader = true;
    this.service.getUserHasObserveEvaluationFilter(this.appConfig.userData.userId, 'quota').subscribe((userHasFilter: any) => {
      this.isUserFilterSetted = true;
      this.userHasFilter = userHasFilter;
      if (!this.userHasFilter) {
        this.noDataFound = true;
        this.filter.showFilter(true);
        // Initialize filterName with default value
        this.filter.setFilterNameFilter(this.layoutService.translateText('EVALUATION.FILTER') + ' 1', true);
      } else {
        // Initialize filterName from user filter data
        const userFilterData = JSON.parse(this.userHasFilter.filterList);
        const filter = userFilterData.Filter[0];
        if (!filter.filterName || filter.filterName.trim() === "") {
          this.filter.setFilterNameFilter(this.layoutService.translateText('EVALUATION.FILTER') + ' 1', true);
        } else {
          this.filter.setFilterNameFilter(filter.filterName, true);
        }
        setTimeout(() => { this.evaluate(true, true); }, 1000)
      }
    }, (error) => { }, () => { this.layoutService.showLoader = false; });
  }

  ngOnDestroy() {
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
  }

  onInitQuota() {
    this.userData = this.appConfig.userData;
    this.filter.showProAndSubPro = false;
    if (this.appConfig.filterDetails.length > 0) {
      this.filter.roleId = this.appConfig.userData.roleName.roleId;
      this.service2.setFilterValue(this.appConfig.filterDetails[0], this.filter);
    }
  }

  evaluate(complianceType = false, setFromUser: boolean = false) {
    this.evaluationLoaded = false;
    this.data = {
      filter: [{
        startDate: this.filter.range.start,
        endDate: this.filter.range.end,
        instutionIDs: "",
        departmentID: "",
        wardID: "",
        professionalCategoryID: "",
        subprofessionalCategoryID: "",
        countryID: 0,
        filterName: this.filter.filterName || this.layoutService.translateText('EVALUATION.FILTER') + ' 1'
      }],

      isBenchMark: true,
      userId: this.userData.userId,
      isSavedFromEvaluation: true,
      roleId: this.userData.roleName.roleId
    }

    var countryColumn = { 'field': 'countryName', 'title': this.layoutService.translateText("AUTHORIZATION.COUNTRY") };
    if (this.userData.roleName.roleId == 1) {
      if (!this.fields.find(field => field.field === 'countryName')) {
        this.fields.splice(2, 0, countryColumn);
      }
    }

    if (this.userData.roleName.roleId == 1 && this.filter.setCountry != 0) {
      this.data.filter[0].countryID = this.filter.setCountry.countryID;
    }

    if (setFromUser) {
      var userFilter = JSON.parse(this.userHasFilter.filterList);
      this.data.filter[0] = this.filter.assignData(userFilter.Filter[0]);
      let startDate = new Date(userFilter.Filter[0].startDate);
      startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
      let endDate = new Date(userFilter.Filter[0].endDate);
      endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
      this.filter.dateRange = [startDate, endDate];
      this.filter.selectDate();
      if (this.userData.roleName.roleId == 1) {
        this.filter.setSAFilter(userFilter.Filter[0], true);
      } else {
        this.filter.setFilterNameFilter(userFilter.Filter[0].filterName, true);
        this.filter.setCountryFilter(userFilter.Filter[0].countryID, userFilter.Filter[0].instutionIDs, userFilter.Filter[0].wardID, true);
        this.filter.setInstitutionsByID(userFilter.Filter[0].instutionIDs, true);
        if (this.filter.wardListLoaded) {
          this.filter.onWardChange(this.filter.wardListLoaded.find(x => x.wardID == userFilter.Filter[0].wardID));
        }

        this.filter.setDepartmentFilter(userFilter.Filter[0].departmentID, true);
        this.filter.setDepartmentTypeFilter(userFilter.Filter[0].departmentTypeID, true);
      }
    } else {
      let currentFilterName = this.data.filter[0].filterName;
      this.data.filter[0] = this.filter.assignData(this.data.filter[0]);
      this.data.filter[0].filterName = currentFilterName;
    }

    this.layoutService.showLoader = true;
    this.isCallFor = "quota";
    if (complianceType) {
      this.isCallFor = "SavedData";
    }
    if (this.appConfig.dropdownChanged == "changed") {
      this.isCallFor = "empty";
    }
    this.service.getQuotaDetails(this.userData.userId, this.data, this.isCallFor, this.userData.country, this.lang, complianceType).subscribe(res => {
      this.appConfig.dropdownChanged = "";
      this.layoutService.showLoader = false;
      if (res.observeEvaluationQuotasList.length == 0) {
        this.noDataFound = true;
      } else {
        this.noDataFound = false;
      }
      const that = this;
      this.gridData = res.observeEvaluationQuotasList.map(item => this.manageGrid(item, that));;
      this.evaluationLoaded = true;
    })
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  emitData(valve) {
    if (valve.value) {
      this.appConfig.filterDetails = valve.value;
      this.appConfig.dropdownChanged = "changed";
    } else {
      this.appConfig.filterDetails = [];
    }
    switch (valve.key) {
      case 'back': this.router.navigate(['evaluation/observeObservation/statistical']); break; // this._location.back();
      case 'overallCompliance': this.router.navigate(['evaluation/observe/overallCompliance']); break;
      case '5Moments': this.router.navigate(['evaluation/observe/fivemoments']); break;
      case 'individualData': this.router.navigate(['evaluation/observe/individualOverview']); break;
      case 'beforeAsepticProcedures': this.router.navigate(['evaluation/observe/StatisticsBeforeAsepticProcedures']); break;
      case 'comments': this.router.navigate(['evaluation/observe/comments']); break;
      case 'quota': this.router.navigate(['evaluation/observe/quota']); break;
      default: this.router.navigate(['evaluation/observeObservation/statistical']); break;
    }
  }

  manageGrid(item, that) {

    let date = that.layoutService.convertUTCStingToLocalDate(item.quotainstitution.quota.startDateTime)
    let lang = localStorage.getItem('selectedlanguage') || 'en';
    if (lang === 'en') {
      lang = 'en-GB';
    }
    item.createdDateTimeStart = date.toLocaleDateString(lang, { month: '2-digit', day: '2-digit', year: 'numeric' });

    date = this.layoutService.convertUTCStingToLocalDate(item.quotainstitution.quota.endDateTime)
    item.createdDateTimeEnd = date.toLocaleDateString(lang, { month: '2-digit', day: '2-digit', year: 'numeric' });

    item.countryName = (item.country !== undefined) ? this.layoutService.translateText(item.country.countryName) : item.country.countryName;

    item.ward = (item.wardName !== '') ? this.layoutService.translateText(item.wardName) : item.wardName;

    item.departmentName = (item.departmentName !== '') ? this.layoutService.translateText(item.departmentName) : item.departmentName;
    item.institutionName = item.quotainstitution.institution.institution.institutionName;
    item.afterBodyFluidExposureRisk = item.quotainstitution.quota.afterBodyFluidExposureRisk;
    item.afterTouchingAPatient = item.quotainstitution.quota.afterTouchingAPatient;
    item.afterTouchingPatientSurrandings = item.quotainstitution.quota.afterTouchingPatientSurrandings;
    item.beforeCleanAsepticProcedures = item.quotainstitution.quota.beforeCleanAsepticProcedures;
    item.beforeTouchingAPatient = item.quotainstitution.quota.beforeTouchingAPatient;

    return item;

  }

  resetFilters() {
    this.filter.resetFilter();
    this.layoutService.showLoader = true;
    setTimeout(() => { this.evaluate(true); }, 1500);
  }

  onFilterSaved() {
    if (!this.userHasFilter) {
      this.layoutService.showLoader = true;
      this.userHasFilter = true;
      setTimeout(() => { this.evaluate(false); }, 1000);
    } else {
      this.evaluate(false);
    }
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  openFilter() {
    this.filter.showFilter(true);
  }
}
